import { useTranslation } from 'react-i18next';

const FamilyBuildingSurrogacyRole = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="surrogacy-journey-label">Surrogacy Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">What best describes your role?</h3>
        
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyDescribe"
            id="surrogacyDescribe1"
            value="Intended Parent"
            checked={formData.SurrogacyDescribe === "Intended Parent"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyDescribe1" className="multistep-form-radio-checkbox-label">Intended Parent</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyDescribe"
            id="surrogacyDescribe2"
            value="Intended Parent (single)"
            checked={formData.SurrogacyDescribe === "Intended Parent (single)"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyDescribe2" className="multistep-form-radio-checkbox-label">Intended Parent (single)</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyDescribe"
            id="surrogacyDescribe3"
            value="Intended Parent (couple)"
            checked={formData.SurrogacyDescribe === "Intended Parent (couple)"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyDescribe3" className="multistep-form-radio-checkbox-label">Intended Parent (couple)</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
    {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingSurrogacyRole;
